import { useEffect, useState } from "react";
import { API_BASE } from "../../lib/apiOrigin";
import { fetchJSON } from "../../lib/fetchJSON";

const ESTIMATE_FIELDS = ["catalog_selection", "category", "surface_type", "concrete_footings_qty", "footings_bare_soil_confirmed", "language", "structure_brand", "product_type", "product_size", "product_links",
  "needs_anchoring", "anchoring_count", "needs_pallet_removal", "pallets_qty", "has_blinds", "blinds_qty", "has_led", "optional_addons"];

let pricesRequest = null;
export function loadCatalogPrices() {
  if (!pricesRequest) pricesRequest = fetchJSON(`${API_BASE}/catalog/prices`).catch(() => { pricesRequest = null; return null; });
  return pricesRequest;
}

export function useCatalogPrices() {
  const [data, setData] = useState(null);
  useEffect(() => { let live = true; loadCatalogPrices().then((d) => { if (live) setData(d); }); return () => { live = false; }; }, []);
  return data;
}

export function estimatePayload(form) {
  return Object.fromEntries(ESTIMATE_FIELDS.map((key) => [key, form[key]]).filter(([, value]) => value !== undefined));
}

// The server is the only price authority; the form shows exactly what it returns.
export function useServerEstimate(form) {
  const [state, setState] = useState({ status: "idle", data: null });
  const key = JSON.stringify(estimatePayload(form));
  useEffect(() => {
    let live = true;
    setState((s) => ({ ...s, status: "loading" }));
    const timer = setTimeout(() => {
      fetchJSON(`${API_BASE}/quotes/estimate`, JSON.parse(key))
        .then((data) => { if (live) setState({ status: "ready", data }); })
        .catch(() => { if (live) setState({ status: "error", data: null }); });
    }, 300);
    return () => { live = false; clearTimeout(timer); };
  }, [key]);
  return state;
}
